import { call, put, takeLatest, delay, select } from "redux-saga/effects"
import { getUsersFailed, getUsersSuccess } from "../actions/userActions"
import { history } from "../helpers/history"
import { userService } from "../services/user.services"

import {
	REQUEST_LOGIN_AZURE,
	HIDE_ALERT,
	LOGIN_FAILURE,
	SHOW_ALERT,
	LOGIN_AZURE,
	LOGIN_SUCCESS,
	REQUEST_SOURCES,
	GET_CONCURRENT_USERS,
	GET_USERS_LIST,
	ERROR_USER,
	LOGOUT,
	GET_USERS_LIST_REQUEST,
} from "../types/index"

/*
function* loginAzureFlow (action) {
    const state = yield select();
    const { oid, name, username } = action.payload;
    let currentUser;
    try{
        currentUser= state.authtentication.user.auth_token;
    }catch(e){
        currentUser=null;
    }
    if (currentUser!==null){
        return;
    }
    //console.log("dispatching loginAzure "+oid);
    //When login is call request data from API
    //User is login
    // dispatch(alertActions.hideAlertAction());
    yield put ({
        type: HIDE_ALERT,
        payload: null
    })
    //Request API
    try{
        // userService.loginAzure(oid, name, username)
        yield call (userService.loginAzure, oid, name, username)
            .then(
                user => {
                        //Verificar los datos que envía la API
                        if (user!==undefined && user.hasOwnProperty("state") && user.state ==="error" && user.hasOwnProperty("errorCode") && user.errorCode ==="Too many Users"){
                            // dispatch(failureUser("You have reached the maximum number of concurrent users. Please contact your administrator and try again."));
                            yield put ({
                                type: LOGIN_FAILURE,
                                payload: "You have reached the maximum number of concurrent users. Please contact your administrator and try again."
                            })
                            history.push('/login-error');
                            return;
                        }
                    if(user.auth_token === undefined){
                        // dispatch(failureUser(user.msg));
                        yield put ({
                            type: LOGIN_FAILURE,
                            payload: user.msg
                        })
                        // dispatch(alertActions.showAlertAction({
                        //     msg: 'User or password not valid. Please login again',
                        //     class: 'alert alert-danger'
                        // }));
                        let alert = {
                            msg: 'User or password not valid. Please login again',
                            class: 'alert alert-danger'
                            };
                        yield put ({
                            type: SHOW_ALERT,
                            payload: alert
                        });
                        // dispatch(startingAzuleLogin(false));
                        yield put ({
                            type: LOGIN_AZURE,
                            payload: false
                        })
                    }else{
                        // dispatch(successUser(user));
                        yield put ({
                            type: LOGIN_SUCCESS,
                            payload: user
                        })
                        // dispatch(requestSources());
                        yield put ({
                            type: REQUEST_SOURCES
                        })
                        history.push('/search');
                        // dispatch(startingAzuleLogin(false));
                        yield put ({
                            type: LOGIN_AZURE,
                            payload: false
                        })
                    }
                },
                error => {
                    // dispatch(failureUser(error));
                    yield put ({
                        type: LOGIN_FAILURE,
                        payload: error
                    })
                    // dispatch(alertActions.showAlertAction({
                    //     msg: 'User or password not valid. Please login again',
                    //     class: 'alert alert-danger'
                    // }));
                    let alert = {
                        msg: 'User or password not valid. Please login again',
                        class: 'alert alert-danger'
                        };
                    yield put ({
                        type: SHOW_ALERT,
                        payload: alert
                    });
                    // dispatch(startingAzuleLogin(false));
                    yield put ({
                        type: LOGIN_AZURE,
                        payload: false
                    })
                }
            );
    }catch(error){
            // dispatch(startingAzuleLogin(false));
            yield put ({
                type: LOGIN_AZURE,
                payload: false
            })
            // dispatch(failureUser(error));
            yield put ({
                type: LOGIN_FAILURE,
                payload: error
            })
            // dispatch(alertActions.showAlertAction({
            //     msg: 'User or password not valid',
            //     class: 'alert alert-danger'
            // }));
            let alert = {
                msg: 'User or password not valid',
                class: 'alert alert-danger'
                };
            yield put ({
                type: SHOW_ALERT,
                payload: alert
            });
    }
}

function* getConcurrentUsersFlow () {
    // userService.getUserList()
    yield call (userService.getUserList)
    .then(
        userList => {
            // dispatch(concurrentUsers(userList));
            yield put ({
                type: GET_USERS_LIST,
                payload: userList
            })            
        }
    );
}

function* errorUserFlow () {
    // dispatch(logoutUser());
    yield put ({
        type: LOGOUT,
        payload: null
    })
    history.push('/');
}*/

// Watches for the UPDATEACCOUNTDETAILS_REQUESTING action type
// When it gets it, it will call verificarFlow()
// WITH the action we dispatched
function* userWatcher() {
	// takeLatest() takes the LATEST call of that action and runs it
	// if we we're to use takeEvery, it would take every single
	// one of the actions and kick off a new task to handle it
	// CONCURRENTLY!!!
	//yield takeLatest(REQUEST_LOGIN_AZURE, loginAzureFlow);
	//yield takeLatest(GET_CONCURRENT_USERS, getConcurrentUsersFlow);
	//yield takeLatest(ERROR_USER, errorUserFlow);
}

export default userWatcher
